import { WebStorageStateStore } from "oidc-client-ts";

const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY_ENDPOINT,
  userStore: new WebStorageStateStore({
    store: localStorage
  }),
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_PUBLIC_URL,
  post_logout_redirect_uri: process.env.REACT_APP_PUBLIC_URL,
  response_type: "code",
  scope: "openid profile LEAGUE_REG_API_SCOPE offline_access",
  filterProtocolClaims: true,
  loadUserInfo: true,
  onSigninCallback: (_user) => {

    if (!!_user.state) {
      window.location.replace(_user.state);
    } else {

      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }

  },
};

const stripe = {
  redirect_uri: process.env.REACT_APP_PUBLIC_URL + '/paymentstatus',
}


export const config = {
  oidcConfig,
  stripe,
  termsOfServiceUrl: process.env.REACT_APP_TERMS_OF_SERVICE_URL,
  privacyPolicyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL,
  ApiUrl: process.env.REACT_APP_API_URL
}
